(function () {
  if (window.__divanoBundleDefined) return;
  window.__divanoBundleDefined = true;


  const DEFAULT_DEBUG = false;
  const DEBUG = (() => {
    if (typeof window.DIVANO_DEBUG === 'boolean') return window.DIVANO_DEBUG;
    try {
      const v = localStorage.getItem('divanoDebug');
      if (v === '0' || v === 'false') return false;
      if (v === '1' || v === 'true') return true;
    } catch {}
    return DEFAULT_DEBUG;
  })();
  const TAG = '[divano-bundle]';
  const log = (...a) => DEBUG && console.log(TAG, ...a);
  const group = (label) => DEBUG && console.groupCollapsed(`${TAG} ${label}`);
  const groupEnd = () => DEBUG && console.groupEnd();
  const warn = (...a) => DEBUG && console.warn(TAG, ...a);
  const error = (...a) => console.error(TAG, ...a);

  function renderTieredPrice({ finalCents, originalCents, compareCents, bundleActive }) {
    const hasCompare = compareCents > 0 && compareCents > originalCents;
    const hasBundle = originalCents > finalCents;
    const tier = (label, cents, cls, dataAttr) =>
      '<span role="group">' +
        '<span class="visually-hidden">' + label + '&nbsp;</span>' +
        '<span class="' + cls + '"' + (dataAttr ? ' ' + dataAttr : '') + '>' + moneyFormat(cents) + '</span>' +
      '</span>';
    const savings = (cents, withBundle) =>
      '<span class="price-savings" role="group" data-savings-money>' +
        'Save ' + moneyFormat(cents) + (withBundle ? ' with bundle' : '') +
      '</span>';
    const saleSavings = (cents) =>
      '<span class="divano-tiered-price__sale-saving" data-sale-savings-money>' +
        moneyFormat(cents) + ' already off the normal price' +
      '</span>';

    const wrap = (inner) => '<span class="divano-tiered-price" data-tiered-price>' + inner + '</span>';

    if (hasCompare && hasBundle) {
      return wrap(tier('Bundle price', finalCents, 'price price--sale', 'data-final-money') +
             tier('Sale price', originalCents, 'compare-at-price', 'data-sale-money') +
             tier('Normal price', compareCents, 'compare-at-price compare-at-price--smaller', 'data-strike-money') +
             savings(originalCents - finalCents, bundleActive) +
             saleSavings(compareCents - originalCents));
    }
    if (hasBundle) {
      return wrap(tier('Bundle price', finalCents, 'price price--sale', 'data-final-money') +
             tier('Sale price', originalCents, 'compare-at-price', 'data-sale-money') +
             savings(originalCents - finalCents, bundleActive));
    }
    if (hasCompare) {
      return wrap(tier('Sale price', originalCents, 'price price--sale', 'data-final-money') +
             tier('Normal price', compareCents, 'compare-at-price', 'data-strike-money') +
             savings(compareCents - originalCents, false));
    }
    return '<span class="price" data-final-money>' + moneyFormat(finalCents) + '</span>';
  }

  function moneyFormat(cents, format) {
    const f = (window.Shopify?.money_format || format || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/g, '');
    const dollars = (cents / 100).toFixed(2);
    const [intPart, decPart] = dollars.split('.');
    const intWithComma = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const prefix = f.replace(/[^$£€¥]/g, '').trim() || '$';
    return `${prefix}${intWithComma}.${decPart}`;
  }

  function moneyShort(cents) {
    const full = moneyFormat(cents);
    return cents % 100 === 0 ? full.replace(/\.00$/, '') : full;
  }

  function updateSetSaving(scope) {
    const span = scope && scope.querySelector('[data-bundle-set-saving]');
    if (!span) return;
    const offset = parseInt(span.dataset.setOffset || '', 10);
    if (Number.isNaN(offset)) return;
    let saving = offset;
    scope.querySelectorAll('[data-pick-price]').forEach((row) => {
      saving += parseInt(row.dataset.pickPrice || '0', 10) || 0;
    });
    const sentence = span.closest('p');
    if (saving > 0) {
      span.textContent = moneyShort(saving);
      if (sentence) sentence.hidden = false;
    } else if (sentence) {
      sentence.hidden = true;
    }
  }

  function wireBundle(section) {
    if (section.dataset.divanoWired === 'true') return;
    section.dataset.divanoWired = 'true';

    if (section.dataset.bundleMode === 'qty_threshold') return;
    const anchorPrice = parseInt(section.dataset.currentPrice || '0', 10);
    const anchorVariantId = section.dataset.currentVariantId;
    const bundleId = section.dataset.bundleId || '(unknown)';
    const items = section.querySelectorAll('.divano-bundle__item[data-pick-variant-id]');
    const subtotalEl = section.querySelector('[data-subtotal]');
    const savingsEl = section.querySelector('[data-savings]');
    const finalEl = section.querySelector('[data-final]');
    const cta = section.querySelector('[data-bundle-add]');
    if (!cta) {
      warn(`bundle ${bundleId}: no [data-bundle-add] CTA found — skipping wiring.`);
      return;
    }
    const anchorPriceBlock = section.querySelector('[data-anchor-price-display]');
    const anchorCompareCents = anchorPriceBlock ? parseInt(anchorPriceBlock.dataset.anchorCompareCents || '0', 10) : 0;

    const mode = section.dataset.bundleMode || '';
    const pricingEnforced = section.dataset.bundlePricingEnforced === 'true';
    const hundredths = (x) => Math.floor(x * 100 + 1e-6) / 100;
    const anchorPct = hundredths(parseFloat(section.dataset.anchorPct || '0') || 0);
    const pickPct = hundredths(parseFloat(section.dataset.pickPct || '0') || 0);
    const anchorFixed = parseFloat(section.dataset.anchorFixed || '0') || 0;
    const pickFixed = parseFloat(section.dataset.pickFixed || '0') || 0;
    const pickFixedCents = Math.floor(pickFixed * 100 + 1e-6);
    const requiresAll = section.dataset.bundleRequiresAll === 'true' || mode === 'bundle_total';
    const bundleTotalCents = section.dataset.bundleTotal ? Math.round(parseFloat(section.dataset.bundleTotal) * 100) : 0;

    group(`init bundle ${bundleId}`);
    log('section:', section);
    log('anchor:', { variantId: anchorVariantId, priceCents: anchorPrice });
    log('mode:', mode, { anchorPct, pickPct, anchorFixed, pickFixed, bundleTotalCents });
    log(`picks (${items.length}):`);
    items.forEach((li) => {
      log('  ', { variantId: li.dataset.pickVariantId, productId: li.dataset.pickProductId, priceCents: parseInt(li.dataset.pickPrice || '0', 10) });
    });
    groupEnd();

    function recalc() {
      let subtotal = anchorPrice;
      let pickCount = 0;
      let pickPctSaving = 0;
      let pickFixedSaving = 0;
      const includedVariantIds = [String(anchorVariantId)];
      items.forEach((li) => {
        const check = li.querySelector('[data-bundle-toggle]');
        const price = parseInt(li.dataset.pickPrice || '0', 10);
        if (check && check.checked) {
          subtotal += price;
          pickPctSaving += Math.floor(price * (pickPct / 100) + 1e-6);
          pickFixedSaving += Math.min(pickFixedCents, price);
          pickCount += 1;
          includedVariantIds.push(li.dataset.pickVariantId);
          li.removeAttribute('data-excluded');
        } else {
          li.setAttribute('data-excluded', 'true');
        }
      });

      const setComplete = requiresAll ? items.length > 0 && pickCount === items.length : pickCount > 0;
      let savings = 0;
      if (pricingEnforced && setComplete) {
        switch (mode) {
          case 'anchor_pct':
          case 'anchor_fixed':
            savings = anchorSavingCents();
            break;
          case 'pick_pct':
            savings = pickPctSaving;
            break;
          case 'pick_fixed':
            savings = pickFixedSaving;
            break;
          case 'bundle_total':
            savings = Math.max(0, subtotal - bundleTotalCents);
            break;
          case 'qty_threshold':
            savings = 0;
            break;
          default:
            savings = 0;
        }
      }
      const final = subtotal - savings;

      if (subtotalEl) subtotalEl.textContent = moneyFormat(subtotal);
      if (pricingEnforced && savingsEl) savingsEl.textContent = `− ${moneyFormat(savings)}`;
      if (pricingEnforced && finalEl) {
        finalEl.textContent = moneyFormat(final);
        finalEl.classList.toggle('price--sale', final < subtotal);
      }

      cta.dataset.variantIds = JSON.stringify(includedVariantIds);
      cta.disabled = includedVariantIds.length === 0 || pickCount === 0;

      updateAnchorRowPrice({ anyPickTicked: setComplete });
      if (pricingEnforced) updateSetSaving(section);

      log(`recalc bundle ${bundleId}:`, {
        included: includedVariantIds,
        subtotalCents: subtotal,
        savingsCents: savings,
        finalCents: final,
      });
    }

    function anchorSavingCents() {
      if (mode === 'anchor_pct') return Math.floor(anchorPrice * (anchorPct / 100) + 1e-6);
      if (mode === 'anchor_fixed') return Math.min(Math.floor(anchorFixed * 100 + 1e-6), anchorPrice);
      return 0;
    }

    function updateAnchorRowPrice({ anyPickTicked }) {
      if (!anchorPriceBlock) return;

      let anchorDiscountCents = 0;
      if (pricingEnforced) anchorDiscountCents = anchorSavingCents();

      const bundleActive = anyPickTicked && anchorDiscountCents > 0;
      const bundleFinal = bundleActive ? anchorPrice - anchorDiscountCents : anchorPrice;

      anchorPriceBlock.innerHTML = renderTieredPrice({
        finalCents: bundleFinal,
        originalCents: anchorPrice,
        compareCents: anchorCompareCents,
        bundleActive: bundleActive
      });

      const anchorMeta = anchorPriceBlock.parentElement;
      const anchorPill = anchorMeta ? anchorMeta.querySelector('[data-bundle-offer-pill]') : null;
      if (anchorPill) {
        anchorPill.style.display = bundleActive ? '' : 'none';
      }
    }

    items.forEach((li) => {
      const check = li.querySelector('[data-bundle-toggle]');
      if (check) check.addEventListener('change', recalc);
    });
    section.divanoRecalc = recalc;

    cta.addEventListener('click', async () => {
      if (cta.dataset.adding === 'true') return;
      const host = section.closest('[data-divano-bundle-pending]');
      const formInput = mainFormVariantInput(section.dataset.productId);
      if (host || (formInput && formInput.value && formInput.value !== String(anchorVariantId))) {
        warn(`bundle ${bundleId}: card variant ${anchorVariantId} is not the selected variant; not adding`);
        return;
      }
      const ids = JSON.parse(cta.dataset.variantIds || '[]');
      if (ids.length === 0) {
        warn('No variant ids on CTA at click. Recalc may not have run yet — try toggling a checkbox then clicking again.');
        return;
      }
      try {
        cta.setAttribute('data-divano-busy', '');
        cta.setAttribute('aria-busy', 'true');
        cta.dataset.adding = 'true';
        const originalText = cta.textContent;
        cta.textContent = 'Adding…';

        const sectionIds = [
          ...new Set(
            [...document.querySelectorAll('cart-items-component')]
              .map((c) => c.dataset.sectionId)
              .filter(Boolean)
          ),
        ];

        const items = ids.map((id) => ({ id: Number(id), quantity: 1 }));
        const images = new Map(ids.map((id) => {
          const row = String(id) === String(anchorVariantId)
            ? section.querySelector('.divano-bundle__item--anchor')
            : [...section.querySelectorAll('[data-pick-variant-id]')].find((row) => row.dataset.pickVariantId === String(id));
          const photo = row?.querySelector('img.divano-bundle__image');
          return [Number(id), photo?.currentSrc || photo?.src || ''];
        }));
        let firstAddedId;
        const t0 = performance.now();
        group(`add bundle ${bundleId}`);
        log('payload:', { items, sections: sectionIds });

        let succeeded = 0, failed = [], lastResponseSections = {};

        const bulk = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items, sections: sectionIds.join(',') }),
        });
        let bulkBody = null;
        try { bulkBody = await bulk.clone().json(); } catch {}
        log(`bulk response: HTTP ${bulk.status} in ${Math.round(performance.now() - t0)}ms`, bulkBody);

        if (bulk.ok) {
          succeeded = items.length;
          firstAddedId = items[0].id;
          if (bulkBody?.sections) lastResponseSections = bulkBody.sections;
        } else {
          const bulkErr = bulkBody?.description || bulkBody?.message || `HTTP ${bulk.status}`;
          warn(`bulk add failed: ${bulkErr}. Retrying items individually...`);

          for (const item of items) {
            const ti = performance.now();
            try {
              const r = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items: [item], sections: sectionIds.join(',') }),
              });
              let body = null;
              try { body = await r.clone().json(); } catch {}
              log(`  retry variant ${item.id}: HTTP ${r.status} in ${Math.round(performance.now() - ti)}ms`, body);
              if (r.ok) {
                if (succeeded === 0) firstAddedId = item.id;
                succeeded++;
                if (body?.sections) lastResponseSections = body.sections;
              } else {
                const msg = body?.description || body?.message || `HTTP ${r.status}`;
                failed.push({ id: item.id, reason: msg });
              }
            } catch (err) {
              failed.push({ id: item.id, reason: String(err) });
              error(`variant ${item.id} threw:`, err);
            }
          }
        }
        log(`summary: succeeded=${succeeded}, failed=${failed.length}, sections=${Object.keys(lastResponseSections).length}`, failed.length ? failed : '');
        groupEnd();

        if (succeeded > 0) {
          window.divanoFlyToCart?.({ source: cta, image: images.get(firstAddedId) || '' });
          let cartState = {};
          try { cartState = await (await fetch('/cart.js')).json(); } catch {}
          const evt = new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cartState,
              sourceId: `divano-bundle:${bundleId}`,
              data: {
                source: 'divano-bundle',
                productId: section.dataset.productId,
                itemCount: cartState.item_count,
                sections: lastResponseSections,
              },
            },
          });
          document.dispatchEvent(evt);
          document.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { resource: cartState, sourceId: `divano-bundle:${bundleId}`, data: { source: 'divano-bundle', sections: lastResponseSections } },
          }));
        }

        if (failed.length === 0) {
          cta.textContent = `Added ${succeeded} item${succeeded === 1 ? '' : 's'} to cart`;
          setTimeout(() => { cta.textContent = originalText; delete cta.dataset.adding; }, 1800);
        } else if (succeeded > 0) {
          cta.textContent = `Added ${succeeded}, ${failed.length} unavailable`;
          setTimeout(() => { cta.textContent = originalText; delete cta.dataset.adding; }, 2800);
        } else {
          cta.textContent = 'Add failed — try again';
          setTimeout(() => { cta.textContent = originalText; delete cta.dataset.adding; }, 2500);
        }
      } finally {
        cta.removeAttribute('data-divano-busy');
        cta.removeAttribute('aria-busy');
      }
    });

    recalc();
  }

  const MULTIBUY = '[data-divano-multibuy]';

  function multibuyScope(target) {
    if (!(target instanceof Element) || target.closest('product-card')) return null;
    return target.closest('.product-details');
  }

  function formVariantInput(scope) {
    return scope ? scope.querySelector('product-form-component input[name="id"]') : null;
  }

  function syncMultibuyEnabled(el, scope) {
    const btn = el.querySelector('[data-qtydeal-add]');
    if (!btn) return;
    const input = formVariantInput(scope);
    const matches = !input || input.value === btn.dataset.qtydealVariantId;
    btn.disabled = !matches;
    if (matches) {
      delete el.dataset.pending;
    } else {
      el.dataset.pending = 'true';
    }
  }

  const multibuyWatchdogs = new WeakMap();

  function clearMultibuyWatchdog(el) {
    clearTimeout(multibuyWatchdogs.get(el));
    multibuyWatchdogs.delete(el);
  }

  function markMultibuyPending(event) {
    const scope = multibuyScope(event.target);
    if (!scope) return;
    scope.querySelectorAll(MULTIBUY).forEach((el) => {
      el.dataset.pending = 'true';
      el.querySelectorAll('[data-qtydeal-add]').forEach((b) => { b.disabled = true; });
      clearMultibuyWatchdog(el);
      multibuyWatchdogs.set(
        el,
        setTimeout(() => {
          multibuyWatchdogs.delete(el);
          if (el.dataset.pending !== 'true') return;
          warn('multi-buy card: no variant arrived for the selection; card removed');
          el.hidden = true;
          el.replaceChildren();
        }, BUNDLE_PENDING_MS)
      );
    });
  }

  function onQtyDealClick(event) {
    const btn = event.target.closest('[data-qtydeal-add]');
    if (!btn) return;
    const host = btn.closest(MULTIBUY);
    const variantId = btn.dataset.qtydealVariantId;
    const qty = parseInt(btn.dataset.qtydealQty || '1', 10);
    if (btn.dataset.adding === 'true' || host?.dataset.pending === 'true') return;
    const input = formVariantInput(multibuyScope(btn));
    if (input && input.value !== variantId) {
      warn(`qty-deal: card variant ${variantId} is not the selected variant "${input.value}"; not adding`);
      return;
    }
    const liveStatus = () => host?.querySelector('[data-qtydeal-status]') || null;
    const cleared = liveStatus();
    if (cleared) cleared.textContent = '';
    (async () => {
      if (!variantId || qty < 1) { warn('qty-deal CTA missing variant/qty'); return; }
      btn.dataset.adding = 'true';
      const original = btn.textContent;
      const image = btn.closest('.shopify-section')?.querySelector('product-form-component add-to-cart-component[data-product-variant-media]')?.dataset.productVariantMedia || '';
      btn.textContent = 'Adding…';
      const sectionIds = [
        ...new Set(
          [...document.querySelectorAll('cart-items-component')]
            .map((c) => c.dataset.sectionId)
            .filter(Boolean)
        ),
      ];
      group(`add qty-deal variant ${variantId} × ${qty}`);
      try {
        btn.setAttribute('data-divano-busy', '');
        btn.setAttribute('aria-busy', 'true');
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }], sections: sectionIds.join(',') }),
        });
        let body = null;
        try { body = await r.clone().json(); } catch {}
        log(`qty-deal add: HTTP ${r.status}`, body);
        if (!r.ok) {
          const msg = body?.description || body?.message || `HTTP ${r.status}`;
          warn(`qty-deal add failed: ${msg}`);
          let refusedSections = {};
          if (sectionIds.length) {
            try {
              const root = window.Shopify?.routes?.root || '/';
              refusedSections = await (await fetch(`${root}?sections=${encodeURIComponent(sectionIds.join(','))}`)).json();
            } catch {}
          }
          await announceCartChange(variantId, host, refusedSections, true);
          const reason = typeof body?.description === 'string' ? body.description.trim().slice(0, 200) : '';
          const status = liveStatus();
          if (reason && status) {
            status.textContent = reason;
            btn.textContent = original;
            delete btn.dataset.adding;
          } else {
            btn.textContent = 'Try again';
            setTimeout(() => { btn.textContent = original; delete btn.dataset.adding; }, 2200);
          }
          groupEnd();
          return;
        }
        window.divanoFlyToCart?.({ source: btn, image });
        await announceCartChange(variantId, host, body?.sections || {});
        btn.textContent = `Added ${qty} to cart`;
        setTimeout(() => { btn.textContent = original; delete btn.dataset.adding; }, 1800);
      } catch (err) {
        error('qty-deal add threw:', err);
        btn.textContent = 'Try again';
        setTimeout(() => { btn.textContent = original; delete btn.dataset.adding; }, 2200);
      } finally {
        btn.removeAttribute('data-divano-busy');
        btn.removeAttribute('aria-busy');
      }
      groupEnd();
    })();
  }

  async function announceCartChange(variantId, host, sections, didError = false) {
    let cartState = {};
    try { cartState = await (await fetch('/cart.js')).json(); } catch {}
    const sourceId = `divano-qtydeal:${variantId}`;
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { resource: cartState, sourceId, data: { source: 'divano-bundle', productId: host?.dataset.productId, itemCount: cartState.item_count, sections, didError } },
    }));
    document.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { resource: cartState, sourceId, data: { source: 'divano-bundle', sections } },
    }));
  }

  function refreshMultibuy(event) {
    const scope = multibuyScope(event.target);
    if (!scope) return;
    const html = event.detail?.data?.html;
    scope.querySelectorAll(MULTIBUY).forEach((el) => {
      const fresh = html && typeof html.querySelector === 'function'
        ? html.querySelector(`${MULTIBUY}[data-block-id="${CSS.escape(el.dataset.blockId || '')}"]`)
        : null;
      delete el.dataset.pending;
      clearMultibuyWatchdog(el);
      if (!fresh) {
        el.hidden = true;
        el.replaceChildren();
        return;
      }
      el.innerHTML = fresh.innerHTML;
      el.hidden = fresh.hidden;
      syncMultibuyEnabled(el, scope);
      clearMultibuyWatchdog(el);
    });
  }

  function wireCartAddButtons(root = document) {
    const items = root.querySelectorAll('.divano-cart-bundle__item[data-bundle-cart-pick]');
    items.forEach((li) => {
      const btn = li.querySelector('[data-bundle-cart-add]');
      if (!btn || btn.dataset.divanoWired === '1') return;
      btn.dataset.divanoWired = '1';
      btn.addEventListener('click', async (ev) => {
        ev.preventDefault();
        if (btn.dataset.adding === '1') return;
        const variantId = li.dataset.pickVariantId;
        if (!variantId) return;
        btn.dataset.adding = '1';
        const originalText = btn.textContent;
        btn.textContent = 'Adding…';
        log(`cart-side add: variant ${variantId}`);
        try {
          btn.setAttribute('data-divano-busy', '');
          btn.setAttribute('aria-busy', 'true');
          const r = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
          });
          let body = null;
          try { body = await r.clone().json(); } catch {}
          log(`  cart-side add response: HTTP ${r.status}`, body);
          if (!r.ok) {
            const msg = body?.description || body?.message || `HTTP ${r.status}`;
            warn(`cart-side add failed for variant ${variantId}:`, msg);
            btn.textContent = 'Try again';
            setTimeout(() => { btn.textContent = originalText; delete btn.dataset.adding; }, 2000);
            return;
          }
          btn.textContent = 'Added';
          btn.dataset.added = '1';
          const image = li.querySelector('.divano-cart-bundle__image');
          window.divanoFlyToCart?.({ source: btn, image: image?.currentSrc || image?.src, allowInCart: true });

          const sectionIds = [
            ...new Set(
              [...document.querySelectorAll('cart-items-component')]
                .map((c) => c.dataset.sectionId)
                .filter(Boolean)
            ),
          ];
          let sectionsHtml = {};
          try {
            const r2 = await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ updates: {}, sections: sectionIds.join(',') }),
            });
            const j = await r2.json();
            if (j?.sections) sectionsHtml = j.sections;
          } catch {}
          let cartState = {};
          try { cartState = await (await fetch('/cart.js')).json(); } catch {}
          window.divanoHighlightCartLine?.({ variantId });
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cartState,
              sourceId: `divano-cart-bundle-pick:${variantId}`,
              data: { source: 'divano-cart-bundle', itemCount: cartState.item_count, sections: sectionsHtml },
            },
          }));
          document.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { resource: cartState, sourceId: `divano-cart-bundle-pick:${variantId}`, data: { source: 'divano-cart-bundle', sections: sectionsHtml } },
          }));
        } catch (err) {
          error('cart-side add threw:', err);
          btn.textContent = 'Try again';
          setTimeout(() => { btn.textContent = originalText; delete btn.dataset.adding; }, 2000);
        } finally {
          btn.removeAttribute('data-divano-busy');
          btn.removeAttribute('aria-busy');
        }
      });
    });
  }

  function handleVariantSelectChange(ev) {
    const select = ev.target.closest('[data-bundle-cart-variant-select]');
    if (!select) return;
    if (select.closest('[data-divano-bundle-pending]')) return;
    const row = select.closest('.divano-cart-bundle__item, .divano-bundle__item');
    if (!row) return;
    const opt = select.selectedOptions[0];
    if (!opt) return;

    row.dataset.pickVariantId = opt.value;
    row.dataset.pickPrice = opt.dataset.price || '';
    const card = row.querySelector('a.divano-cart-bundle__card-link, a.divano-bundle__card-link, .divano-cart-bundle__card, a.divano-bundle__card');
    if (card && card.href) {
      const legacyId = String(opt.value).split('/').pop();
      card.href = card.href.replace(/([?&])variant=\d+/, `$1variant=${legacyId}`);
    }

    const priceBlock = row.querySelector('[data-pick-price-display]');
    if (priceBlock) {
      const scope = row.closest('[data-bundle-pricing-enforced]');
      const pricingEnforced = scope ? scope.dataset.bundlePricingEnforced === 'true' : false;
      const originalCents = parseInt(opt.dataset.price || '0', 10);
      let finalCents = parseInt(opt.dataset.discountedPrice || opt.dataset.price || '0', 10);
      const compareCents = parseInt(opt.dataset.compareCents || '0', 10);
      let bundleActive = parseInt(opt.dataset.hasDiscount || '0', 10) > 0;
      if (!pricingEnforced) {
        finalCents = originalCents;
        bundleActive = false;
      }
      priceBlock.innerHTML = renderTieredPrice({ finalCents, originalCents, compareCents, bundleActive });

      const pickProductId = row.dataset.pickProductId;
      const idSel = scope && pickProductId ? CSS.escape(pickProductId) : '';
      if (idSel && opt.dataset.amountShort) {
        scope.querySelectorAll(`[data-bundle-pick-amount="${idSel}"]`).forEach((el) => {
          el.textContent = opt.dataset.amountShort;
        });
      }
      if (pricingEnforced && idSel && opt.dataset.savingShort) {
        scope.querySelectorAll(`[data-bundle-pick-saving="${idSel}"]`).forEach((el) => {
          el.textContent = opt.dataset.savingShort;
        });
        const pill = row.querySelector('[data-bundle-offer-pill]');
        if (pill && scope.dataset.bundleMode === 'pick_fixed') {
          pill.textContent = `BUNDLE\u00a0·\u00a0${opt.dataset.savingShort.toUpperCase()} OFF`;
        }
      }
      if (pricingEnforced && scope) updateSetSaving(scope);
    }

    const bundleSection = row.closest('.divano-bundle');
    const toggle = row.querySelector('[data-bundle-toggle]');
    if (bundleSection && typeof bundleSection.divanoRecalc === 'function') {
      bundleSection.divanoRecalc();
    } else if (toggle) {
      toggle.dispatchEvent(new Event('change', { bubbles: true }));
    }
    log('variant select changed for row:', { variantId: row.dataset.pickVariantId, priceCents: row.dataset.pickPrice });
  }

  const BUNDLE_HOST = '[data-divano-bundle-host]';
  const bundleFetches = new Map();
  const bundleGen = new Map();
  let cartGen = 0;
  const bundleWatchdogs = new Map();
  const BUNDLE_PENDING_MS = 10000;

  function bundleBump(sectionId) {
    const next = (bundleGen.get(sectionId) || 0) + 1;
    bundleGen.set(sectionId, next);
    bundleFetches.get(sectionId)?.abort();
    bundleFetches.delete(sectionId);
    clearTimeout(bundleWatchdogs.get(sectionId));
    bundleWatchdogs.delete(sectionId);
    return next;
  }

  function mainViewScope(target) {
    if (!(target instanceof Element)) return null;
    if (target.closest('product-card, quick-add-component, quick-add-dialog')) return null;
    return target.closest('.product-details');
  }

  function mainFormVariantInput(productId) {
    if (!productId) return null;
    for (const input of document.querySelectorAll('product-form-component input[name="id"]')) {
      if (input.closest('product-card, quick-add-component, quick-add-dialog')) continue;
      const form = input.closest('product-form-component');
      if (form && String(form.dataset.productId || '') === String(productId)) return input;
    }
    return null;
  }

  function bundleHostsFor(event) {
    const scope = mainViewScope(event.target);
    const productId = String(
      event.detail?.data?.productId ||
        event.target.closest('[data-product-id]')?.dataset.productId ||
        scope?.querySelector('product-form-component[data-product-id]')?.dataset.productId ||
        ''
    );
    return [...document.querySelectorAll(BUNDLE_HOST)].filter((host) => !productId || host.dataset.productId === productId);
  }

  function bundleWrapper(host) {
    return host.closest('[id^="shopify-section-"]');
  }

  function clearBundleCards(wrap, host) {
    wrap.replaceChildren(host);
    delete wrap.dataset.divanoBundlePending;
  }

  function setBundlePending(wrap) {
    wrap.dataset.divanoBundlePending = 'true';
    wrap.querySelectorAll('[data-bundle-add]').forEach((b) => {
      if (b === document.activeElement) b.setAttribute('aria-disabled', 'true');
      else b.disabled = true;
    });
    wrap.querySelectorAll('[data-bundle-cart-variant-select]').forEach((s) => { s.disabled = true; });
  }

  function markBundlesPending(event) {
    if (!mainViewScope(event.target)) return;
    bundleHostsFor(event).forEach((host) => {
      const wrap = bundleWrapper(host);
      const sectionId = host.dataset.sectionId;
      if (!wrap || !sectionId) return;
      const token = bundleBump(sectionId);
      setBundlePending(wrap);
      bundleWatchdogs.set(
        sectionId,
        setTimeout(() => {
          bundleWatchdogs.delete(sectionId);
          if (bundleGen.get(sectionId) !== token) return;
          warn(`bundle section ${sectionId}: no variant arrived for the selection; cards removed`);
          const liveHost = wrap.querySelector(BUNDLE_HOST) || host;
          clearBundleCards(wrap, liveHost);
        }, BUNDLE_PENDING_MS)
      );
    });
  }

  function refreshBundleSections(event) {
    if (!mainViewScope(event.target)) return;
    const variantId = event.detail?.resource?.id;
    const newProduct = event.detail?.data?.newProduct;
    bundleHostsFor(event).forEach((host) => {
      const wrap = bundleWrapper(host);
      const sectionId = host.dataset.sectionId;
      if (!wrap || !sectionId) return;
      const formInput = mainFormVariantInput(host.dataset.productId);
      if (formInput && String(formInput.value || '') !== String(variantId || '')) {
        warn(`bundle section ${sectionId}: ignoring a variant:update for ${variantId}; the form holds "${formInput.value}"`);
        return;
      }
      const token = bundleBump(sectionId);
      if (!variantId || newProduct) {
        clearBundleCards(wrap, host);
        return;
      }
      setBundlePending(wrap);
      loadBundleSection(host, wrap, sectionId, variantId, token);
    });
  }

  function loadBundleSection(host, wrap, sectionId, variantId, token) {
    const cartAtStart = cartGen;
    const controller = new AbortController();
    bundleFetches.set(sectionId, controller);
    const url = `${host.dataset.productUrl}?variant=${encodeURIComponent(variantId)}&section_id=${encodeURIComponent(sectionId)}`;
    fetch(url, { signal: controller.signal })
      .then((r) => (r.ok ? r.text() : Promise.reject(new Error(`HTTP ${r.status}`))))
      .then((text) => {
        if (bundleGen.get(sectionId) !== token) return;
        if (cartGen !== cartAtStart) {
          const next = bundleBump(sectionId);
          setBundlePending(wrap);
          loadBundleSection(host, wrap, sectionId, variantId, next);
          return;
        }
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const fresh = doc.getElementById(wrap.id);
        const freshHost = fresh && fresh.querySelector(BUNDLE_HOST);
        if (!freshHost || freshHost.dataset.variantId !== String(variantId)) {
          throw new Error('the render is not this section for the selected variant');
        }
        wrap.innerHTML = fresh.innerHTML;
        delete wrap.dataset.divanoBundlePending;
        wrap.querySelectorAll('.divano-bundle').forEach(wireBundle);
      })
      .catch((err) => {
        if (err.name === 'AbortError') return;
        if (bundleGen.get(sectionId) !== token) return;
        warn(`bundle section ${sectionId}: refresh for variant ${variantId} failed (${err.message}); cards removed`);
        const liveHost = wrap.querySelector(BUNDLE_HOST) || host;
        clearBundleCards(wrap, liveHost);
      })
      .finally(() => {
        if (bundleFetches.get(sectionId) === controller) bundleFetches.delete(sectionId);
      });
  }

  function onPickerInput(event) {
    if (!(event.target instanceof Element)) return;
    if (!event.target.closest('variant-picker, divano-variant-picker, swatches-variant-picker-component')) return;
    markBundlesPending(event);
    markMultibuyPending(event);
  }

  function init() {
    document.querySelectorAll('.divano-bundle').forEach(wireBundle);
    document.addEventListener('variant:selected', markBundlesPending);
    document.addEventListener('divano:variant:select', markBundlesPending);
    document.addEventListener('variant:update', refreshBundleSections);
    document.addEventListener('change', onPickerInput);
    document.addEventListener('input', onPickerInput);
    document.addEventListener('click', onQtyDealClick);
    document.addEventListener('variant:selected', markMultibuyPending);
    document.addEventListener('divano:variant:select', markMultibuyPending);
    document.addEventListener('variant:update', refreshMultibuy);
    wireCartAddButtons();
    document.addEventListener('change', handleVariantSelectChange);
    document.addEventListener('cart:update', () => {
      cartGen += 1;
      setTimeout(() => wireCartAddButtons(), 50);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
